import React from "react";
import ArticleElement from "./ArticleElement";
import { getPrettyDate } from "../lib/format";
import { useApi } from "../lib/useApi";

// The section header shown above an article in each category (PartitionKey).
const SECTION_HEADERS = new Map([
  ["Soccer10OfTheDay", "SOCCER 10 OF THE DAY"],
  ["Soccer6OfTheDay", "SOCCER 6 OF THE DAY"],
  ["Soccer4OfTheDay", "SOCCER 4 OF THE DAY"],
  ["Soccer13OfTheDay", "SOCCER 13 OF WEEK"],
  ["Soccer13XOfTheDay", "SOCCER ANY 13 XTRA"],
  ["Mega10OfTheDay", "MEGA 10 JACKPOT"],
  ["StoryOfWeek", "STORY OF THE WEEK"],
  ["Briefs", "BRIEFS"],
  ["Tip", "WHAT THEY SAID"],
  ["Soccer10Payout", "SOCCER 10 PAYOUT"],
  ["Soccer13Payout", "SOCCER 13 PAYOUT"],
  ["Soccer6Payout", "SOCCER 6 PAYOUT"],
  ["Column", "COLUMN"],
  ["Preview", "PREVIEW"],
]);

const ArticlesElement = () => {
  const positionArticles = (json_articles) => {
    const positioned_articles = [];
    for (const article of json_articles) {
      let updated_article = {
        date: getPrettyDate(article.RowKey.substring(0, 10)),
        title: article.title,
        author: article.author,
        strap_line: article.strap_line,
        raw_date_id: article.RowKey,
      };
      updated_article["category"] = article.PartitionKey;
      if (SECTION_HEADERS.has(article.PartitionKey)) {
        updated_article["header"] = SECTION_HEADERS.get(article.PartitionKey);
      }
      positioned_articles.push(updated_article);
    }
    return positioned_articles;
  };

  const { data: PositionedArticles = [] } = useApi(`/api/GetArticles`, { select: positionArticles });

  return (
    <div>
      <div className="row fifth">
        <div className="large-4 columns" style={{ paddingLeft: "0", paddingRight: "0.3em" }}>
          {PositionedArticles.map((article) => (
            <ArticleElement article={article} />
          ))}
          <div className="divider"></div>
        </div>
      </div>
    </div>
  );
};

export default ArticlesElement;
